import React from "react";
import Layout from "../../Layout";
import ScoringPersona from "../../containers/Scoring/Persona";

export default function ScoringPersonaPage() {
  return (
    <Layout>
      <ScoringPersona />
    </Layout>
  );
}
